export const up = (levels: number) => {
    const levelsArray = window.location.pathname.split("/").filter(str => str !== "");

    return `/${levelsArray.slice(0, 0 - levels).join("/")}`;
}